import React, { useState , useEffect}  from 'react';
import { useStateContext } from '../../contexts/ContextProvider';
import DataTable from 'react-data-table-component';
import EditIconButton from "../../components/IconButtons/EditIconButton";
import DeleteIconButton from "../../components/IconButtons/DeleteIconButton";
import {AiOutlineUserAdd} from 'react-icons/ai';
import { TooltipComponent } from '@syncfusion/ej2-react-popups';
import { FormParametros } from '../../components';
import {getParametros} from '../../services/parametros';
import {useParametrosMutations} from '../../hooks/parametros/useParametrosMutations';

const NavButton = ({ title, customFunc, icon, color, texto }) => (
  <TooltipComponent content={title} position="BottomCenter">
      <button
        type="button"
        onClick={() => customFunc()}
        style={{ backgroundColor: color}}
        className="relative text-xl  text-white rounded-lg p-3 hover:bg-light-gray"
      >
      <div className="flex flex-row justify-between items-center">
        <div>{icon}</div>
        <div><p className="text-xs ">{texto}</p></div>
      </div>
    </button>

  </TooltipComponent>
);

const Parametros = () => {
    const { currentColor, handleClick, isClicked } = useStateContext();
    const [archivosData, setArchivosData] = useState([]);
    const [laSucursal, setLaSucursal] = useState("");
    const {removeParam} = useParametrosMutations();

    useEffect(()=>{
      const fetchData = async () => {
        const misParam = await getParametros();
        setArchivosData(misParam);
      };
      fetchData();
    },[]);

    const handleSubmit = () => {

    };


  return (

    <div className="m-2 md:m-10 mt-16 p-2 md:p-4 bg-gray-100 rounded-3xl">


    <div className="container mx-auto p-2 md:p-2">
        <h1 className="text-2xl font-semibold mb-6">Parámetros</h1>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="md:col-span-2 bg-white p-6 rounded-lg shadow-lg">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4" >
                    <div className="flex flex-col ">
                        <label className="text-sm font-semibold mb-1">Codigo</label>
                        <input
                            type="text"
                            className="border border-gray-300 p-2 rounded"
                            value={""}
                            onChange={(e) => (e.target.value)}
                        />
                    </div>
                    <div className="col-span-2">
                    <div className="flex flex-col ">
                        <label className="text-sm font-semibold mb-1">Descripción</label>
                        <input
                            type="text"
                            className="border border-gray-300 p-2 rounded"
                            value={""}
                            onChange={(e) => (e.target.value)}
                        />
                    </div>
                    </div>
                    <div className="flex flex-col">
                        <p className="text-xs text-gray-600"> Estado </p>
                        <select className="text-xs border-gray-200 outline-none border-2 p-2  focus:border-gray-300" name="estado" value= {""} required onChange={()=>("")}>
                            <option value="ACTIVO">Activo</option>
                            <option value="INACTIVO">Inactivo</option>
                            <option value="ELIMINADO">Eliminado</option>
                        </select>
                    </div>
               </div>

               
            </div>
            <div className="bg-white p-6 rounded-lg shadow-lg">
                <button
                    onClick={handleSubmit}
                    className="bg-blue-600 text-white py-2 px-4 rounded mt-4"
                >
                Guardar
                </button>
            </div>
        </div>
    </div>


</div>
  )
}

export default Parametros